import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';

/**
 * Configuration Firebase — utilise les variables d'environnement.
 * Créer un fichier .env.local à la racine avec :
 *   REACT_APP_FIREBASE_API_KEY=...
 *   REACT_APP_FIREBASE_AUTH_DOMAIN=...
 *   etc.
 * Les valeurs par défaut permettent le fonctionnement en dev.
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDH1BTlNjU1fkMp8DX9RhfIIoBMZC85d60',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'contenuia.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'contenuia',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'contenuia.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '1035243427862',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:1035243427862:web:bf252d43db38fb12cf3d37',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-0NHW02LJ68',
};

let app: FirebaseApp;
let auth: Auth;
let db: Firestore;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
} catch (e) {
  console.error('[Firebase] Initialisation échouée:', e);
  throw new Error("Impossible d'initialiser Firebase. Vérifiez la configuration.");
}

export { auth, db };
export default app;
